import React, { useState } from 'react'
import { Html } from "@react-three/drei";

export default function InfoBox({ 
    title = "Info",
    description,
    children,
    position = [0, 0, 0],
}) {
    const [showInfo, setShowInfo] = useState(false);

    // css styles
    const white = '#f9f9f9';
    const black = '#36383F';
    const gray = '#85888C';
    const green = '#3FB950';

    const buttonStyle = {
        textAlign: 'center',
        backgroundColor: white,
        color: black,
        border: 'none',
        borderRadius: '50%',
        boxShadow: `3px 3px 3px ${gray}`,
        width: '30px',
        height: '30px',
        fontSize: '1.5rem',
        fontStyle: 'bold',
        cursor: 'pointer',
    }

    const infoBoxStyle = {
        backgroundColor: white,
        color: black,
        borderRadius: '10px',
        boxShadow: `3px 3px 3px ${gray}`,
        fontSize: '0.8rem',
        padding: '15px',
    }

    const closeStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
    }

    return (
            showInfo ?
                <div
                    className="info-box"
                    style={infoBoxStyle}
                >
                    <div
                        onClick={() => setShowInfo(false)}
                        style={closeStyle}
                    >
                        X
                    </div>
                    <h2>{ title }</h2>
                    <p>{ description }</p>
                    { children }
                </div> :
                <div
                    className="info-box"
                    style={buttonStyle}
                    onClick={() => setShowInfo(true)}
                >
                    <i className="fa fa-info"></i>
                </div>
    );
}
